import styled from 'styled-components';

export const TriggerContainer = styled.div<{ $isDisabled: boolean }>`
  cursor: ${p => (p.$isDisabled ? 'default' : 'pointer')};
`;
